import Enums from 'utils/EnumsManager';
import { toUtc, toTimezone } from 'utils/dateTimeUtils';
import { WorkFlowCriteria } from '../models/index';

const { WorkFlow, FieldTypes } = Enums;
const { UserInput, ContextAttributes, ShortChecker } = WorkFlow;
const {
  DateOnly, DateTime, Lookup, PickList
} = FieldTypes;

const getMaxDisplayNum = (data, key) => {
  if (!_.isArray(data) || _.isEmpty(data)) return 0;
  const lastElement = data[data.length - 1];
  return lastElement && lastElement[key] ? lastElement[key] : 0;
};

const updateCriteria = (criteria, columnKey, colmunNum, value) => (
  criteria.map(c => {
    if (c.displayNum === colmunNum) {
      return {
        ...c,
        [columnKey]: value,
      };
    }
    return c;
  })
);

const formatSiderOptions = (options, fieldType) => {
  const optionsCopy = _.cloneDeep(options);
  let formatOptions = [];
  if (fieldType === Lookup) {
    formatOptions = optionsCopy.map(opt => ({
      label: opt.name,
      value: opt.id
    }));
  }
  if (fieldType === PickList) {
    formatOptions = optionsCopy.map(opt => ({
      label: opt.option_value,
      value: opt.id
    }));
  }
  return formatOptions;
};

// split the input string based on the longest match in option list
const mapSelectedValue = (arr, str) => {
  let inputStringWithoutWhitespacesAndLower = str.replace(/\s/g, '').toLowerCase();
  const optionList = arr;
  const sortedOptionList = [...optionList].sort((a, b) => b.label.length - a.label.length);
  const output = [];
  // stop the loop if the substring of inputString is ""
  while (inputStringWithoutWhitespacesAndLower.length > 0) {
    let hasCountry = false;
    for (let i = 0; i < sortedOptionList.length; i++) {
      const optionValWithoutWhitespacesAndLower = sortedOptionList[i].label.replace(/\s/g, '').toLowerCase();
      if (inputStringWithoutWhitespacesAndLower.startsWith(optionValWithoutWhitespacesAndLower)) {
        const matchedValue = sortedOptionList[i].label.replaceAll("'", "\\\'");
        output.push(matchedValue);
        hasCountry = true;
        inputStringWithoutWhitespacesAndLower = inputStringWithoutWhitespacesAndLower.substring(optionValWithoutWhitespacesAndLower.length + 1, inputStringWithoutWhitespacesAndLower.length).trim();
        break;
      }
    }
    // if there is NO startswith match value in the option list
    if (!hasCountry) {
      const commaIndex = inputStringWithoutWhitespacesAndLower.indexOf(',');
      // if it's NOT the last substring in the inputString
      if (commaIndex > -1) {
        inputStringWithoutWhitespacesAndLower = inputStringWithoutWhitespacesAndLower.substring(commaIndex + 1, inputStringWithoutWhitespacesAndLower.length).trim();
      } else {
        inputStringWithoutWhitespacesAndLower = '';
      }
    }
  }
  return output;
};

const valueToArray = (value) => {
  if (_.isEmpty(value) || !_.isString(value)) return [];
  return value.trim().split(',').filter(s => s !== '').map(str => str.trim());
};


const setSelectedValue = (value, rightSiderList) => {
  if (_.isEmpty(value) || !_.isString(value)) return [];
  return mapSelectedValue(rightSiderList, value);
};

// deal with the country list which has ',' inside
const criterialToApiWithRightSider = (criteria, rightSiderList) => {
  const {
    displayNum,
    functionType,
    conditionId,
    fieldId,
    type,
    value,
    valueType
  } = criteria;
  const parseFilter = [{
    type: ContextAttributes,
    value: fieldId
  }];
  let subFilter = [];
  if (functionType !== ShortChecker) {
    if (valueType === UserInput) {
      switch (type) {
        case DateOnly:
        case DateTime:
          subFilter = [{
            type: valueType,
            value: toUtc(value, type === DateTime)
          }];
          break;
        case Lookup:
        case PickList:
        default:
          const parseValue = setSelectedValue(value, rightSiderList);
          subFilter = parseValue.map(v => ({
            type: valueType,
            value: v
          }));
          break;
      }
    } else {
      subFilter = [{
        type: valueType,
        value
      }];
    }
  }
  if (!_.isEmpty(subFilter)) {
    parseFilter.push(subFilter);
  }
  return {
    display_num: displayNum,
    function_type: functionType,
    function_name: conditionId,
    params: parseFilter
  };
};

const criterialToApi = props => {
  const {
    displayNum,
    functionType,
    conditionId,
    fieldId,
    type,
    value,
    valueType
  } = props;
  const parseFilter = [{
    type: ContextAttributes,
    value: fieldId
  }];
  let subFilter = [];
  if (functionType !== ShortChecker) {
    if (valueType === UserInput) {
      switch (type) {
        case DateOnly:
        case DateTime:
          subFilter = [{
            type: valueType,
            value: toUtc(value, type === DateTime)
          }];
          break;
        case Lookup:
        case PickList:
        default:
          const parseValue = valueToArray(value);
          subFilter = parseValue.map(v => ({
            type: valueType,
            value: v
          }));
          break;
      }
    } else {
      subFilter = [{
        type: valueType,
        value
      }];
    }
  }
  if (!_.isEmpty(subFilter)) {
    parseFilter.push(subFilter);
  }
  return {
    display_num: displayNum,
    function_type: functionType,
    function_name: conditionId,
    params: parseFilter
  };
};

const parseApiCriteriaValue = (data, fieldsType, valueType) => {
  if (_.isEmpty(data)) return '';
  const parseData = [];
  data.forEach(d => parseData.push(d.value));
  const stringData = parseData.join(',').trim();
  if (valueType === UserInput && (fieldsType === DateOnly || fieldsType === DateTime)) {
    return toTimezone(stringData, fieldsType === DateTime);
  }
  return stringData;
};

const apiToCriterial = (subCondition, FieldsMata) => {
  const { params } = subCondition;
  if (!_.isArray(params) || _.isEmpty(params)) return new WorkFlowCriteria({ ...subCondition });
  const valueData = params.length > 1 && !_.isEmpty(params[1]) ? params[1] : [];
  const selectedField = FieldsMata.find(f => f.id === params[0].value);
  const valueType = valueData && !_.isEmpty(valueData[0]) ? valueData[0].type : '';
  return new WorkFlowCriteria({
    ...subCondition,
    fieldId: params[0].value,
    valueType,
    value: parseApiCriteriaValue(valueData, selectedField ? selectedField.dataType : '', valueType),
    type: selectedField ? selectedField.dataType : ''
  });
};

export {
  getMaxDisplayNum,
  updateCriteria,
  formatSiderOptions,
  valueToArray,
  criterialToApi,
  criterialToApiWithRightSider,
  apiToCriterial
};



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/utils/criterialUtils.js